import useTranslation from 'next-translate/useTranslation';
import InviteeStep from '@/components/referral/InviteeStep';
import InviteeCoupon from '@/components/referral/InviteeCoupon';
import useClickActionT2 from '@/tracks/useClickActionT2';
import { twMerge } from 'tailwind-merge';
import Link from 'next/link';
import Img from '@/components/common/Img';
import { ArrowRight } from '@weee-fe/kunlunicon';
import { useRouter } from 'next/router';
import { useCroppedImage } from '@weee-fe/module';
import LoginV3 from '@/components/login/LoginV3';

type InviteeHeroProps = {
  data: any;
  currentStep: number;
  handleNextStep: (step: number) => void;
  isMobile?: boolean;
  isLogin?: boolean;
};

const InviteeHero = ({ data, currentStep, handleNextStep, isMobile, isLogin }: InviteeHeroProps) => {
  const router = useRouter();
  const { query } = router;
  const { t } = useTranslation('common');
  const { getCroppedUrl } = useCroppedImage();

  const { buttonClickView } = useClickActionT2();

  const clickTrack = type => {
    buttonClickView({
      co: {
        target_nm: type
      },
      ctx: {
        step: currentStep ? 2 : 1
      }
    });
  };

  return (
    <div
      style={{
        background: `url(${
          process.env.CDN_COMMON_ASSETS_PATH || process.env.NEXT_PUBLIC_CDN_COMMON_ASSETS_PATH
        }/referral/hero-bottom.png) no-repeat bottom/auto 112px`
      }}
      className={twMerge('w-full h-full flex flex-col min-h-[calc(100vh-48px)]')}>
      {!isLogin && <InviteeStep currentStep={currentStep} />}
      <div className="pb-[112px]">
        {currentStep === 0 && (
          <InviteeCoupon data={data} onNextStep={handleNextStep} clickTrack={clickTrack} isLogin={isLogin} />
        )}
        {currentStep === 1 && (
          <section data-testid="wid-invitee-clam-coupon" className="mt-3">
            <div data-testid="wid-invitee-clam-coupon-title" className="enki-heading-2xl text-primary-1 text-center">
              {t('invite_friends_share_title_step02')}
            </div>
            <div className="max-w-[350px] mx-auto mt-6">
              <LoginV3 showAreaTitle={false} defaultActiveLoginMethod="phone" />
            </div>
            {query?.is_student === '1' && (
              <Link prefetch={false} href={data?.student?.url}>
                <div className="max-w-[350px] mx-auto mt-5 px-5 text-left">
                  <div className="flex items-center px-5 py-2 rounded-xl bg-[#E6F2F0] text-[#043E42] enki-body-2xs">
                    <Img
                      data-testid="wid-invitee-clam-coupon-student-icon"
                      className="w-5 flex-none"
                      src={data?.student?.icon}
                    />
                    <div className="flex-1 mx-2">
                      <div
                        data-testid="wid-invitee-clam-coupon-student-title"
                        className="enki-body-base-medium"
                        dangerouslySetInnerHTML={{ __html: data?.student?.title }}></div>
                      <div
                        data-testid="wid-invitee-clam-coupon-student-sub-title"
                        dangerouslySetInnerHTML={{ __html: data?.student?.sub_title }}></div>
                    </div>
                    <ArrowRight fontSize={16} />
                  </div>
                </div>
              </Link>
            )}
          </section>
        )}
      </div>
    </div>
  );
};

export default InviteeHero;
